const STORAGE_KEY = 'remembered_login_email';

export function getRememberedLoginEmail(): string | null {
  if (typeof window === 'undefined') {
    return null;
  }

  try {
    return localStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
}

export function setRememberedLoginEmail(email: string | null): void {
  if (typeof window === 'undefined') {
    return;
  }

  try {
    if (email) {
      localStorage.setItem(STORAGE_KEY, email);
    } else {
      localStorage.removeItem(STORAGE_KEY);
    }
  } catch {
    // storage blocked
  }
}
